/**
 * @file 远程加载语言包
 * @author svon.me@gmail.com
 */

import tool from "@/utils/tool";
import sysConfig from "@/config";
import * as Language from "./language";
import {setValue} from "@/locales/cache";
import safeGet from "@fengqiaogang/safe-get";

export const getLanguage = function () {
  return tool.data.get("APP_LANG") || sysConfig.LANG
}


export const load = async function () {
  const key = getLanguage();
  const type = String(key).replace(/\W/ig, "");
  if (Language[type]) {
    const module = await Language[type]();
    let value;
    if (module && module.default) {
      value = module.default
    } else {
      value = module;
    }
    setValue(key, safeGet(value, key) || {});
  }
}
